<template>
  <LangDropdown
    v-model="model"
    lang-code-key="iso_code"
    id-key="language_profile_id"
    :options="options"
    :disabled="isLoading"
  />
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import i18n, { defaultLang as defaultLangCode } from "@shared/plugins/i18n";
import LangDropdown from "@shared/components/LangDropdown";
import VueCookies from "vue-cookies";

const defaultLangData = {
  language_profile_id: "default",
  name: "English",
}

export default {
  name: "language-menu",  
  components: {
    LangDropdown,
  },
  data() {
    return {
      isLoading: false,
      currentLangProfile: null,
    }
  },

  async mounted() {
      this.currentLangProfile = VueCookies.get("tenantLanguage");
      await this.fetchTenantTranslationData();
  },
  computed: {
    ...mapGetters({
      langProfileOptions: "getTenantLangProfileList",
      "getTenantTranslations": "getTenantTranslations",
    }),

    defaultLang() {
      return this.langProfileOptions.find((el) => el.iso_code === defaultLangCode) ?? defaultLangData;
    },

    model: {
      get() {
        // eslint-disable-next-line no-unused-vars
        const { icon, ...value } = (this.currentLangProfile || this.defaultLang);
        return value;
      },
      set(val) {
        this.changeLang(val);
      }
    },

    // TODO add flag icons
    options() {
      return this.langProfileOptions;
    },
  },

  methods: {
    ...mapActions({
      fetchLangProfileTranslations: "fetchLangProfileTranslations",
    }),
    async changeLang(langProfile) {
      if (!langProfile.language_profile_id) return;
      this.isLoading = true;
      try {
        VueCookies.set("tenantLanguage", JSON.stringify(langProfile))
        this.currentLangProfile = langProfile;
        await this.fetchTenantTranslationData();
      } catch (error) {
        console.error("Error while changing language profile", error);
      }
      this.isLoading = false;
    },

    async fetchTenantTranslationData() {
        let langProfileTranslations = this.getTenantTranslations?.[this.currentLangProfile?.language_profile_id];
        
        if (!langProfileTranslations) {
          const fetchedTranslations = await this.fetchLangProfileTranslations(this.currentLangProfile);     
          langProfileTranslations = fetchedTranslations?.data?.translations;
        }   
        i18n.locale = this.currentLangProfile?.language_profile_id;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>